//住所を取得
export function getAddress(master, restApi, postCode, fn, setDialog) {
  const originalPost = master.originalPost.find((item) => {
    // 郵便番号の比較は数字のみで行う
    const itemPostCodeNum = String(item.POST_CODE).replace(/\D/g, '');
    const postCodeNum = String(postCode).replace(/\D/g, '');
    if (itemPostCodeNum === postCodeNum) {
      return item;
    }
  });

  // 特殊郵便番号が見つかった場合はその情報を返す
  if (originalPost) {
    fn({
      results: [
        {
          address1: originalPost.PREF,
          address2: originalPost.CITY,
          address3: originalPost.TOWN,
        },
      ],
    });
    return;
  }

  restApi.get(
    `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postCode}`,
    (json) => {
      //存在しない郵便番号エラー
      if (!json['results']) {
        setDialog({
          type: 'error',
          message: '郵便番号に誤りがあります。',
        });
        return;
      }
      fn(json);
    },
    {}
  );
}
